import { CATEGORY_ICON_MAP } from "./categoryIcons";
import { MessageSquare } from "lucide-react";

export function getCategoryIcon(iconKey?: string) {
  if (!iconKey) return MessageSquare;

  const normalized = iconKey.toLowerCase().trim();
  return CATEGORY_ICON_MAP[normalized] || MessageSquare;
}
